module.exports = __webpack_public_path__ + "img/1557614088523161601.2605c9ef.png";